import { formatCurrency, formatDate } from '@/utils/formatUtils';
import { getPenaltyReasonTranslationKey, resolvePenaltyReason } from '@/config/penaltyReasons';

export const getPenaltyDisplay = (penalty, t, { sale } = {}) => {
  if (!penalty) {
    return null;
  }

  const amount = penalty.outstandingAmount || 0;
  const amountLabel = amount ? formatCurrency(amount) : null;
  const dueLabel = penalty.dueAt ? formatDate(penalty.dueAt) : null;
  const reason = resolvePenaltyReason(penalty, sale);
  const reasonKey = getPenaltyReasonTranslationKey(reason);

  return {
    amountLabel,
    dueLabel,
    reasonLabel: t(reasonKey),
  };
};
